import { useMemo } from "react";

import { useFeaturesByLayer } from "fond/hooks/useFeaturesByLayer";
import { MuPowerOutputLayerIds } from "fond/types";

import { PhaseNetwork } from "./phaseNetwork";

const PHASE_NETWORK_LAYER_KEYS = [MuPowerOutputLayerIds.primaryWires, MuPowerOutputLayerIds.transformers, MuPowerOutputLayerIds.sources];

/**
 * Builds the PhaseNetwork for the given project version.
 */
export const usePhaseNetwork = (versionId: string): { network: PhaseNetwork; isLoading: boolean } => {
  const { featuresByLayer, isLoading } = useFeaturesByLayer(versionId, PHASE_NETWORK_LAYER_KEYS);

  const network = useMemo(
    () =>
      new PhaseNetwork(
        featuresByLayer[MuPowerOutputLayerIds.primaryWires] ?? [],
        featuresByLayer[MuPowerOutputLayerIds.transformers] ?? [],
        featuresByLayer[MuPowerOutputLayerIds.sources] ?? []
      ),
    [featuresByLayer]
  );

  return { network, isLoading };
};
